module.exports = __webpack_public_path__ + "static/media/del.03d90fee.PNG";